// Local search presentation engine resolver.
//
// Content search is displayed from Algolia only; Fuse + MiniSearch content
// providers run as shadows (searchReporter). For non-content registries both
// local engines always run and `presentationEngine` (configured in
// SearchProviderContainer, exposed via SupplementarySearchContext) decides
// which engine's results the UI presents. This maps a logical local source to
// the concrete provider id for the selected engine.

export const PRESENTATION_ENGINES = { FUSE: 'fuse', MINISEARCH: 'minisearch' }

const LOCAL_PROVIDER_IDS = {
  content: { fuse: 'fuse-content', minisearch: 'minisearch-content' },
  navigation: { fuse: 'navigation', minisearch: 'navigation-minisearch' },
  'external-help': { fuse: 'external-help', minisearch: 'external-help-minisearch' },
  'quick-actions': { fuse: 'quick-actions', minisearch: 'quick-actions-minisearch' },
}

/**
 * Resolve a logical local source (`content`, `navigation`, `external-help`,
 * `quick-actions`) to the additive provider id for the given engine. Falls back
 * to the Fuse id for an unknown engine, and returns the base unchanged for an
 * unknown source.
 *
 * @param {string} base
 * @param {('fuse'|'minisearch')} engine
 * @returns {string}
 */
export function localProviderId(base, engine) {
  const row = LOCAL_PROVIDER_IDS[base]
  if (!row) return base
  return row[engine] || row.fuse
}
